module.exports = __webpack_public_path__ + "static/media/arrow_right.0b41871a.svg";